import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=171a865f"
import script from "./faq.vue?vue&type=script&lang=ts"
export * from "./faq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiAccordion: require('/vercel/path0/components/ui/accordion.vue').default,UiLink: require('/vercel/path0/components/ui/link.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
